module.exports = __webpack_public_path__ + "static/img/userVisitHistory.dbef9ecc.png";